import React from "react";
import { BallotStatus } from "../types/portalTypes";

export const getBallotStatusText = (status: BallotStatus) => {
    switch (status) {
        case BallotStatus.Draft:
            return "Draft";
        case BallotStatus.Complete:
            return "Complete";
        case BallotStatus.Live:
            return "Live";
        case BallotStatus.Paused:
            return "Paused";
        case BallotStatus.Published:
            return "Published";
        case BallotStatus.Proxy:
            return "Proxy";
    }
}

export const getBallotStatusLabel = (status: BallotStatus) => {
    let text = getBallotStatusText(status);
    let className = "";

    switch (status) {
        case BallotStatus.Draft:
            className = "bg-gray-400 text-gray-900";
            break;
        case BallotStatus.Complete:
            className = "bg-green-400 text-gray-900";
            break;
        case BallotStatus.Live:
            className = "bg-blue-400 text-green-900";
            break;
        case BallotStatus.Paused:
            className = "bg-yellow-400 text-yellow-900";
            break;
        case BallotStatus.Published:
            className = "bg-purple-400 text-blue-900";
            break;
        default:
            className = "bg-neutral-400 text-neutral-900";
            break;
    }

    return (
        <span className={`inline-block px-2 py-1 rounded text-xs font-medium uppercase w-full text-center ${className}`}>
            {text}
        </span>
    );
};